import React from 'react';
import { Steps } from 'antd';
import moment from 'moment';
import { TextLabel } from '../../../../components/TextLabel';
import TextTable from '../../../../components/TextTable';

const { Step } = Steps;

const ListSteps: React.FC<any> = ({ record }) => {
  const customDot = (dot: React.ReactNode) => <>{dot}</>;
  let activeStep = 0;
  switch (record.status) {
    case 'SL':
      activeStep = 0;
      break;
    case 'AA':
      activeStep = 1;
      break;
    case 'AC':
      activeStep = 1;
      break;

    case 'AG':
      activeStep = 2;
      break;

    case 'NE':
      activeStep = 3;
      break;

    case 'EX':
      activeStep = 4;
      break;
    default:
      activeStep = -1;
      break;
  }

  return (
    <>
      <Steps className="steps" responsive={true} current={activeStep} progressDot={customDot}>
        <Step
          title={<TextLabel>Solicitado</TextLabel>}
          description={
            activeStep >= 0 && (
              <div
                style={{
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                {moment(!!record.dhSolicitado ? record.dhSolicitado : record.dtSolicitacao).format(
                  'LL'
                )}
              </div>
            )
          }
        />
        <Step
          title={<TextLabel>Aguardando Agendamento</TextLabel>}
          description={
            activeStep > 0 &&
            record?.dhAguardandoAgendamento && (
              <div
                style={{
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                {moment(record.dhAguardandoAgendamento).format('LL')}
              </div>
            )
          }
        />
        <Step
          title={<TextLabel>Agendado</TextLabel>}
          description={
            activeStep > 1 &&
            record.dhAgendado && (
              <div
                style={{
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                {moment(record.dhAgendado).format('LL')}
              </div>
            )
          }
        />
        <Step
          title={<TextLabel>Nota emitida</TextLabel>}
          description={
            activeStep > 2 &&
            record?.dhNotaEmitida && (
              <div
                style={{
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                {moment(record?.dhNotaEmitida).format('LL')}
              </div>
            )
          }
        />
        <Step
          title={<TextLabel>Expedido</TextLabel>}
          description={
            activeStep > 3 &&
            record?.dhExpedido && (
              <div
                style={{
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                {moment(record?.dhExpedido).format('LL')}
              </div>
            )
          }
        />
      </Steps>
    </>
  );
};

export default ListSteps;
